import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {MenuBehaviorSubject} from '../layout/services/menu-behavior-subject';

@Injectable()
export class CanNavigationGuard implements CanActivateChild {
  constructor(
    private routerRedirect: Router,
    private menuBehaviorSubject: MenuBehaviorSubject,
  ) {}

  public canNavigate: boolean = false;

  public validate(url: string, currentUrl: string) {
    return url.includes(currentUrl);
  }

  public canActivateChild(route: ActivatedRouteSnapshot, router: RouterStateSnapshot) {
    const allUrls = [];
    allUrls.push('/app/dashboard');

    if (!this.menuBehaviorSubject.menuValue.value) {

      this.menuBehaviorSubject.menuValue.subscribe( (res) => {
        if (!!res) {
          res.forEach( (item) => {
            this.addUniqueUrls(item, allUrls);
          });
        }

        allUrls.forEach( (url) => {
          if (this.validate(url, router.url)) {
            this.canNavigate = true;
          } else {
            this.canNavigate = false;
          }
        });
      });
    } else {
      this.menuBehaviorSubject.menuValue.value.forEach( (item: any) => {
        this.addUniqueUrls(item, allUrls);
      });

      allUrls.forEach( (url) => {
        if (this.validate(url, router.url)) {
          this.canNavigate = true;
        }
      });
    }

    if (!this.canNavigate) {
      this.routerRedirect.navigate(['app/dashboard']);
    }

    return this.canNavigate;
  }

  private addUniqueUrls(item: any, allUrls: any[]) {
    if (Array.isArray(item.url)) {
      item.url.forEach( (subUrl: any) => {
        if (allUrls.indexOf(subUrl.url) === -1) {
          allUrls.push(subUrl.url);
        }
      });
    } else {
      if (allUrls.indexOf(item.url) === -1) {
        allUrls.push(item.url);
      }
    }
  }
}
